<div class="card">
    <div class="chart-container">
        <p-organizationChart [value]="chartData" [collapsible]="true">
            <ng-template let-node pTemplate="default">
                <div class="p-3 border-1 surface-border border-round"
                    [ngClass]="getNodeClass(node.data?.adjustmentType)">
                    <div class="label">{{ node.label }}</div>
                    <div class="grid-2-col">
                        <div><strong>Created:</strong> {{ node.data?.createdDate || 'N/A' }}</div>
                        <div><strong>Status:</strong> {{ node.data?.statusDescription || 'N/A' }}</div>
                        <div><strong>Timesheet IDs:</strong> {{ node.data?.timesheets || 'N/A' }}</div>
                        <div><strong>Charges:</strong> {{ node.data?.totalCharges ?? 0 }}</div>
                        @if(!node.data?.adjustmentType?.toLowerCase().includes('void')){
                        <div><strong>Paid:</strong> {{ node.data?.paymentAmount ?? 0 }}</div>
                        <div><strong>Payment Date:</strong> {{ node.data?.paymentDate || 'N/A' }}</div>
                        <div><strong>ICN:</strong> {{ node.data?.icn || 'N/A' }}</div>
                        }
                        @if(node.data?.outstandingBalance){
                        <div><strong>Outstanding Amount:</strong> {{ node.data?.outstandingBalance ?? 0 }}</div>
                        }
                    </div>
                </div>
            </ng-template>
        </p-organizationChart>
    </div>
</div>